export default {
  data() {
    return {
      o_m_tr: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$sn.assembly.loading(false);
    this.$sn.vuex.set('vuex_toast', {});
    this.$sn.vuex.set('vuex_modal', {});
    next();
  },
  mounted() {
    this.$nextTick(() => {
      window.eventBus.$on('Broadcast_LanguageComplete', () => {
        this.$sn.TR.execute();
      });
      if (this.o_m_tr) {
        this.$sn.TR.execute();
      }
    });
  }
};
